import { Fragment } from "react";

import useNTGroupAthletes from "./UseNTGroupAthletes";

import NTGroupAthletesInitiate from "./NTGroupAthletesInitiate";
import NTGroupAthletesBulkAdd from "./NTGroupAthletesBulkAdd";
import NTGroupAthletesManualInvite from "./NTGroupAthletesManualInvite";

import NTGroupsLoadingModal from "../components/dialogs/loading/NTGroupsLoadingModal";

import {
  ATHLETE_PILL_STEP_BULK_ADD, ATHLETE_PILL_STEP_INITIATE, ATHLETE_PILL_STEP_MANUAL_INVITE
} from "../utils/NTGroupConstants";

import Headings from "@usas/ui-web/components/headings/Headings";

const NTGroupAthletes = () => {
  const {
    currentStep,
    updateAthletePillStep
  } = useNTGroupAthletes();

  switch (currentStep) {
    case ATHLETE_PILL_STEP_INITIATE:
      return <NTGroupAthletesInitiate updateAthletePillStep={updateAthletePillStep} />;

    case ATHLETE_PILL_STEP_BULK_ADD:
      return <NTGroupAthletesBulkAdd updateAthletePillStep={updateAthletePillStep} />;

    case ATHLETE_PILL_STEP_MANUAL_INVITE:
      return <NTGroupAthletesManualInvite />;

    default:
      return (
        <Fragment>
          <div className="row">
            <div className="col-xs-12">
              <Headings.H3>Athletes</Headings.H3>
            </div>
          </div>
          <NTGroupsLoadingModal isLoading={true} />
        </Fragment>
      );
  }
};

export default NTGroupAthletes;